export default __webpack_public_path__ + "static/media/right-triangle-benefits.649d6c5a.png";